// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  height: 100%;
}

ngx-monaco-editor {
  object-fit: fill;
  height: calc(100vh - 100px) !important;
}

.progress {
  margin-bottom: 5px;
  font-size: 15px;
}

.save-error {
  margin-bottom: 5px;
  color: red;
  font-size: 15px;
}

a.save-error {
  text-decoration: none;
}

a.save-error:hover {
  -webkit-text-decoration: under;
          text-decoration: under;
}

.isDisabled {
  text-decoration: none;
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.new {
  color: rgba(0, 0, 0, 0.5);
  font-style: italic;
}

.fix-padding {
  padding: 0.6em 0 0 0 !important;
}

.tags-list {
  width: 100%;
}

#searchInput {
  margin-left: 10px;
}

.clickable {
  cursor: pointer;
}

.toolbar {
  padding: 0 var(--content-margin);
}

.toolbar mat-checkbox {
  margin-top: 8px;
}

.content.compact {
  position: relative;
}
.content.compact .adapter-form {
  gap: 0;
}
.content.compact .form-field-row.compact-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  margin-bottom: 4px;
  padding-left: 0;
}
.content.compact .compact-name {
  width: 250px;
  min-width: 250px;
  max-width: 250px;
  flex-shrink: 0;
}
.content.compact .compact-field-md {
  min-width: 150px;
  flex: 1;
}
.content.compact .compact-field-sm {
  min-width: 100px;
  max-width: 140px;
  flex: 1 1 auto;
}
.content.compact .compact-field-xs {
  min-width: 80px;
  max-width: 120px;
  flex: 1 1 auto;
}
.content.compact .compact-info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 8px 0;
  align-items: flex-start;
}
.content.compact .compact-info-row .info-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.content.compact .compact-info-row .info-group .info-label {
  font-size: 11px;
  opacity: 0.6;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.content.compact .compact-info-row .info-group .info-value {
  font-size: 13px;
  opacity: 0.87;
}
.content.compact .compact-info-row .info-group .info-value.info-features {
  line-height: 1.4;
}
.content.compact .compact-info-row .info-group .info-value.status-value.running {
  color: #2196f3;
}
.content.compact .compact-info-row .info-group .info-value.status-value.complete {
  color: #4caf50;
}
.content.compact .compact-info-row .info-group .info-value.status-value.cancelled {
  color: #ff9800;
}
.content.compact .new-build-section {
  margin-bottom: 24px;
}
.content.compact .new-build-section .section-header {
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.2);
}
.content.compact .new-build-section .section-header .section-title {
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.7;
}
.content.compact .new-build-section .section-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.content.compact .new-build-section .section-content.horizontal {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
}
.content.compact .new-build-section .section-help {
  font-size: 12px;
  opacity: 0.6;
  line-height: 1.5;
  margin: 8px 0 0 0;
}
.content.compact .new-build-section .section-help strong {
  opacity: 1;
}
.content.compact .new-build-section .field-row {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: flex-end;
}
.content.compact .new-build-section .field-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.content.compact .new-build-section .field-group.field-grow {
  flex: 1;
  min-width: 200px;
}
.content.compact .new-build-section .field-group .field-help {
  font-size: 11px;
  opacity: 0.5;
  padding-left: 4px;
  line-height: 1.3;
}
.content.compact .new-build-section .field-sm {
  width: 120px;
}
.content.compact .new-build-section .field-sm.field-date {
  width: 150px;
}
.content.compact .new-build-section .field-md {
  width: 280px;
}
.content.compact .new-build-section .field-full {
  width: 100%;
}
.content.compact .two-column-row {
  display: flex;
  gap: 32px;
}
.content.compact .two-column-row .new-build-section {
  flex: 1;
  min-width: 0;
  margin-bottom: 0;
}
.content.compact ::ng-deep .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  padding-top: 4px;
  padding-bottom: 4px;
}
.content.compact ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-infix {
  min-height: 32px;
  padding-top: 6px;
  padding-bottom: 6px;
}
.content.compact ::ng-deep .mat-mdc-form-field .mat-mdc-floating-label {
  top: 16px;
}
.content.compact ::ng-deep .mat-mdc-form-field .mdc-floating-label--float-above {
  transform: translateY(-90%) scale(0.75);
}
.content.compact ::ng-deep .mat-mdc-form-field.features-field .mat-mdc-text-field-wrapper {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
.content.compact ::ng-deep .mat-mdc-form-field.features-field .mat-mdc-form-field-infix {
  min-height: 80px !important;
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}
.content.compact ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.content.compact ::ng-deep .mat-mdc-chip {
  height: 22px;
  font-size: 11px;
}
.content.compact ::ng-deep .mat-mdc-chip .mat-mdc-chip-action-label {
  padding: 0 6px;
}
.content.compact ::ng-deep .mat-mdc-chip .mat-mdc-chip-remove {
  width: 14px;
  height: 14px;
}
.content.compact ::ng-deep .mat-mdc-chip .mat-mdc-chip-remove mat-icon {
  font-size: 12px;
  width: 12px;
  height: 12px;
}
.content.compact ::ng-deep .cdk-drop-list-dragging {
  overflow: hidden !important;
}
.content.compact ::ng-deep .cdk-drag-placeholder {
  opacity: 0.5;
}
.content.compact ::ng-deep .cdk-drag-preview {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
}
.content.compact .features-field,
.content.compact .features-field * {
  overflow: hidden !important;
}
.content.compact.loading .adapter-form {
  opacity: 0.5;
  pointer-events: none;
}

.loading-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

mat-chip-row {
  overflow: hidden !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/data/schema/schema.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,sCAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,8BAAA;UAAA,sBAAA;AACF;;AAEA;EACE,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,gCAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAOA;EACE,kBAAA;AAJF;AAME;EACE,MAAA;AAJJ;AAOE;EACE,aAAA;EACA,iBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AALJ;AASE;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAPJ;AAUE;EACE,gBAAA;EACA,OAAA;AARJ;AAWE;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;AATJ;AAYE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAVJ;AAcE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,uBAAA;AAZJ;AAcI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAZN;AAcM;EACE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;AAZR;AAeM;EACE,eAAA;EACA,aAAA;AAbR;AAeQ;EACE,gBAAA;AAbV;AAiBU;EAAY,cAAA;AAdtB;AAeU;EAAa,cAAA;AAZvB;AAaU;EAAc,cAAA;AAVxB;AAiBE;EACE,mBAAA;AAfJ;AAiBI;EACE,mBAAA;EACA,mBAAA;EACA,iDAAA;AAfN;AAiBM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;AAfR;AAmBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAjBN;AAmBM;EACE,mBAAA;EACA,eAAA;EACA,SAAA;AAjBR;AAqBI;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAnBN;AAqBM;EACE,UAAA;AAnBR;AAuBI;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,qBAAA;AArBN;AAwBI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAtBN;AAwBM;EACE,OAAA;EACA,gBAAA;AAtBR;AAyBM;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAvBR;AA4BI;EACE,YAAA;AA1BN;AA6BM;EACE,YAAA;AA3BR;AA+BI;EACE,YAAA;AA7BN;AAgCI;EACE,WAAA;AA9BN;AAmCE;EACE,aAAA;EACA,SAAA;AAjCJ;AAmCI;EACE,OAAA;EACA,YAAA;EACA,gBAAA;AAjCN;AAwCM;EACE,gBAAA;EACA,mBAAA;AAtCR;AAyCM;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AAvCR;AA0CM;EACE,SAAA;AAxCR;AA2CM;EACE,uCAAA;AAzCR;AA8CQ;EACE,4BAAA;EACA,+BAAA;AA5CV;AA+CQ;EACE,2BAAA;EACA,4BAAA;EACA,+BAAA;AA7CV;AAmDI;EACE,aAAA;AAjDN;AAqDI;EACE,YAAA;EACA,eAAA;AAnDN;AAqDM;EACE,cAAA;AAnDR;AAsDM;EACE,WAAA;EACA,YAAA;AApDR;AAsDQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AApDV;AA0DI;EACE,2BAAA;AAxDN;AA2DI;EACE,YAAA;AAzDN;AA4DI;EACE,wCAAA;AA1DN;AA+DE;;EAEE,2BAAA;AA7DJ;AAkEI;EACE,YAAA;EACA,oBAAA;AAhEN;;AAsEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;AAnEF;;AAsEA;EACE,2BAAA;AAnEF","sourcesContent":[".content {\n  height: 100%;\n}\n\nngx-monaco-editor {\n  object-fit: fill;\n  height: calc(100vh - 100px) !important;\n}\n\n.progress {\n  margin-bottom: 5px;\n  font-size: 15px;\n}\n\n.save-error {\n  margin-bottom: 5px;\n  color: red;\n  font-size: 15px;\n}\n\na.save-error {\n  text-decoration: none;\n}\n\na.save-error:hover {\n  text-decoration: under;\n}\n\n.isDisabled {\n  text-decoration: none;\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.new {\n  color: rgba(0, 0, 0, 0.5);\n  font-style: italic;\n}\n\n.fix-padding {\n  padding: 0.6em 0 0 0 !important;\n}\n\n.tags-list {\n  width: 100%;\n}\n\n#searchInput {\n  margin-left: 10px;\n}\n\n// .adapter-form {\n//   margin-top: var(--content-margin);\n// }\n\n.clickable {\n  cursor: pointer;\n}\n\n.toolbar {\n  padding: 0 var(--content-margin);\n}\n\n.toolbar mat-checkbox {\n  margin-top: 8px;\n}\n\n// Compact mode styles\n.content.compact {\n  position: relative;\n\n  .adapter-form {\n    gap: 0;\n  }\n\n  .form-field-row.compact-row {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 8px;\n    margin-bottom: 4px;\n    padding-left: 0;\n  }\n\n  // Name field - fixed width\n  .compact-name {\n    width: 250px;\n    min-width: 250px;\n    max-width: 250px;\n    flex-shrink: 0;\n  }\n\n  .compact-field-md {\n    min-width: 150px;\n    flex: 1;\n  }\n\n  .compact-field-sm {\n    min-width: 100px;\n    max-width: 140px;\n    flex: 1 1 auto;\n  }\n\n  .compact-field-xs {\n    min-width: 80px;\n    max-width: 120px;\n    flex: 1 1 auto;\n  }\n\n  // Static info display for existing builds\n  .compact-info-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    padding: 8px 0;\n    align-items: flex-start;\n\n    .info-group {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n\n      .info-label {\n        font-size: 11px;\n        opacity: 0.6;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n      }\n\n      .info-value {\n        font-size: 13px;\n        opacity: 0.87;\n\n        &.info-features {\n          line-height: 1.4;\n        }\n\n        &.status-value {\n          &.running { color: #2196f3; }\n          &.complete { color: #4caf50; }\n          &.cancelled { color: #ff9800; }\n        }\n      }\n    }\n  }\n\n  // New build form layout - spacious with sections\n  .new-build-section {\n    margin-bottom: 24px;\n\n    .section-header {\n      margin-bottom: 12px;\n      padding-bottom: 8px;\n      border-bottom: 1px solid rgba(128, 128, 128, 0.2);\n\n      .section-title {\n        font-size: 14px;\n        font-weight: 500;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        opacity: 0.7;\n      }\n    }\n\n    .section-content {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n\n      &.horizontal {\n        flex-direction: row;\n        flex-wrap: wrap;\n        gap: 12px;\n      }\n    }\n\n    .section-help {\n      font-size: 12px;\n      opacity: 0.6;\n      line-height: 1.5;\n      margin: 8px 0 0 0;\n\n      strong {\n        opacity: 1;\n      }\n    }\n\n    .field-row {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 24px;\n      align-items: flex-end;\n    }\n\n    .field-group {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      &.field-grow {\n        flex: 1;\n        min-width: 200px;\n      }\n\n      .field-help {\n        font-size: 11px;\n        opacity: 0.5;\n        padding-left: 4px;\n        line-height: 1.3;\n      }\n    }\n\n    // Field sizes for new build form\n    .field-sm {\n      width: 120px;\n\n      // Split Date needs more width to show full label\n      &.field-date {\n        width: 150px;\n      }\n    }\n\n    .field-md {\n      width: 280px;\n    }\n\n    .field-full {\n      width: 100%;\n    }\n  }\n\n  // Two-column layout for sections side by side\n  .two-column-row {\n    display: flex;\n    gap: 32px;\n\n    .new-build-section {\n      flex: 1;\n      min-width: 0;\n      margin-bottom: 0;\n    }\n  }\n\n  // Reduce form field height in compact mode\n  ::ng-deep {\n    .mat-mdc-form-field {\n      .mat-mdc-text-field-wrapper {\n        padding-top: 4px;\n        padding-bottom: 4px;\n      }\n\n      .mat-mdc-form-field-infix {\n        min-height: 32px;\n        padding-top: 6px;\n        padding-bottom: 6px;\n      }\n\n      .mat-mdc-floating-label {\n        top: 16px;\n      }\n\n      .mdc-floating-label--float-above {\n        transform: translateY(-90%) scale(0.75);\n      }\n\n      // Features field override - taller for the star of the show\n      &.features-field {\n        .mat-mdc-text-field-wrapper {\n          padding-top: 12px !important;\n          padding-bottom: 12px !important;\n        }\n\n        .mat-mdc-form-field-infix {\n          min-height: 80px !important;\n          padding-top: 16px !important;\n          padding-bottom: 16px !important;\n        }\n      }\n    }\n\n    // Remove subscript space (hints/errors) in compact mode\n    .mat-mdc-form-field-subscript-wrapper {\n      display: none;\n    }\n\n    // Smaller chips in compact mode\n    .mat-mdc-chip {\n      height: 22px;\n      font-size: 11px;\n\n      .mat-mdc-chip-action-label {\n        padding: 0 6px;\n      }\n\n      .mat-mdc-chip-remove {\n        width: 14px;\n        height: 14px;\n\n        mat-icon {\n          font-size: 12px;\n          width: 12px;\n          height: 12px;\n        }\n      }\n    }\n\n    // Prevent scrollbars during drag-drop\n    .cdk-drop-list-dragging {\n      overflow: hidden !important;\n    }\n\n    .cdk-drag-placeholder {\n      opacity: 0.5;\n    }\n\n    .cdk-drag-preview {\n      box-shadow: 0 3px 6px rgba(0,0,0,0.2);\n    }\n  }\n\n  // Prevent scrollbars on features field during drag\n  .features-field,\n  .features-field * {\n    overflow: hidden !important;\n  }\n\n  // Loading state - dim the form\n  &.loading {\n    .adapter-form {\n      opacity: 0.5;\n      pointer-events: none;\n    }\n  }\n}\n\n// Loading overlay\n.loading-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10;\n}\n\nmat-chip-row {\n  overflow:hidden!important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
